import React, { FC, useState } from 'react';
import { useFormik } from 'formik';
import { RefundInputs } from '../../../constants/refund/refund-inputs';
import { convertToInitialRefundValues, getRefundDetailSchema } from '../../../constants/refund/refund-form';
import { IDisputeItem } from '../../../store/tables/disputes/disputes-data';
import { DisputeFormInputs } from '../../orders/DisputeFormInputs';
import { setRefund } from '../../../store/disputes/actions/disputes';
import { BUTTON_TYPE, ButtonComponent } from '../../ButtonComponent';

interface Props {
	data: IDisputeItem;
	closeModal: () => void;
	onSuccess?: () => void;
	onError?: () => void;
}

export const RefundForm: FC<Props> = (props) => {
	const { data, closeModal, onSuccess, onError } = props;
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const formik = useFormik({
		initialValues: convertToInitialRefundValues(data),
		validationSchema: getRefundDetailSchema,
		onSubmit: async () => {
			setIsLoading(true);
			await setRefund(formik, onSuccess, onError);
			setIsLoading(false);
		}
	});

	const INPUTS = RefundInputs();
	return (
		<form onSubmit={formik.handleSubmit} className="row px-8">
			{
				INPUTS?.map(el => (
					<DisputeFormInputs formik={formik} {...el} key={el.key}/>
				))
			}
			<div className="text-center my-5">
				<ButtonComponent
					buttonName="Cancel"
					buttonType={BUTTON_TYPE.CANCELLED}
					additionalClass="btn-sm"
					onButtonClick={closeModal}
				/>
				<ButtonComponent
					buttonName="Confirm"
					type="submit"
					additionalClass="btn-sm ms-10"
					loading={isLoading}
				/>
			</div>
		</form>
	);
};
